import 'core-js/es/promise';
import 'core-js/es/symbol';
import 'core-js/es/weak-map';
import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js/es/array/from';
import 'core-js/es/array/includes';
import 'core-js/es/string/includes';
import 'core-js/es/string/starts-with';
import 'core-js/es/string/ends-with';
import 'core-js/es/object/assign';
import 'core-js/es/object/entries';
import 'whatwg-fetch';
